import React, { useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelopeOpen } from "react-icons/fa";

const ContactForm = () => {
  // États pour le formulaire
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  // États pour la gestion du chargement et des messages
  const [isLoading, setIsLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState(""); // 'success' ou 'error'

  // Gestion des changements dans les inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Gestion de la soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation basique
    if (!formData.fullName || !formData.email || !formData.message) {
      setStatusType("error");
      setStatusMessage("Veuillez remplir tous les champs obligatoires.");
      return;
    }

    setIsLoading(true);
    setStatusMessage("");
    setStatusType("");

    try {
      // Simulation d'envoi - Remplacez par votre endpoint réel
      // Option 1: Utiliser EmailJS, Formspree, ou votre backend
      const response = await fetch("https://formspree.io/f/YOUR_FORM_ID", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: "contact@hg-services.com",
          from: formData.email,
          subject: formData.subject || "Nouveau message de contact",
          name: formData.fullName,
          phone: formData.phone,
          message: formData.message,
        }),
      });

      if (response.ok) {
        setStatusType("success");
        setStatusMessage(
          "Votre message a été envoyé avec succès ! Nous vous répondrons dans les plus brefs délais."
        );
        // Réinitialiser le formulaire
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      } else {
        throw new Error("Erreur lors de l'envoi");
      }
    } catch (error) {
      setStatusType("error");
      setStatusMessage(
        "Une erreur s'est produite lors de l'envoi. Veuillez réessayer ou nous contacter directement par téléphone."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="tp-contact-area pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-10">
              <div
                className="section-title-wrapper-two mb-50 wow fadeInUp"
                data-wow-delay=".2s"
              >
                <h5 className="tp-section-subtitle section__sm__title common-yellow-shape mb-20 heading-color-black">
                  Get Free Estimate
                </h5>
                <h2 className="tp-section-title heading-color-black">
                  If you Have Any Query, Don't Hesitate <br />
                  Contact with us
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="row custom-mar-20">
                <div className="col-lg-12 col-md-4 col-sm-6 custom-pad-20">
                  <div
                    className="tp-contact-info mb-40 wow fadeInUp"
                    data-wow-delay=".4s"
                  >
                    <div className="tp-contact-info-icon">
                      <i>
                        <FaMapMarkerAlt className="contact_icon" />
                      </i>
                    </div>
                    <div className="tp-contact-info-text">
                      <h4 className="tp-contact-info-title mb-15">Address</h4>
                      <p>
                        YATCHIKA GSB CHANTEVA <br />
                        Douala Cameroun.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-4 col-sm-6 custom-pad-20">
                  <div
                    className="tp-contact-info mb-40 wow fadeInUp"
                    data-wow-delay=".6s"
                  >
                    <div className="tp-contact-info-icon">
                      <i>
                        <FaPhoneAlt className="contact_icon" />
                      </i>
                    </div>
                    <div className="tp-contact-info-text">
                      <h4 className="tp-contact-info-title mb-15">Phone</h4>
                      <a href="tel:+237687788330">687 78 83 30</a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-4 col-sm-6 custom-pad-20">
                  <div
                    className="tp-contact-info mb-40 wow fadeInUp"
                    data-wow-delay=".8s"
                  >
                    <div className="tp-contact-info-icon">
                      <i>
                        <FaEnvelopeOpen className="contact_icon" />
                      </i>
                    </div>
                    <div className="tp-contact-info-text">
                      <h4 className="tp-contact-info-title mb-15">Email</h4>
                      <a href="mailto:contact@hg-services.com">
                        contact@hg-services.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="tp-contact-form">
                {/* Message de statut */}
                {statusMessage && (
                  <div
                    className={`alert alert-${
                      statusType === "success" ? "success" : "danger"
                    } mb-20`}
                    style={{
                      padding: "15px",
                      borderRadius: "5px",
                      backgroundColor:
                        statusType === "success" ? "#d4edda" : "#f8d7da",
                      color: statusType === "success" ? "#155724" : "#721c24",
                      border: `1px solid ${
                        statusType === "success" ? "#c3e6cb" : "#f5c6cb"
                      }`,
                    }}
                  >
                    {statusMessage}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row custom-mar-20">
                    <div className="col-md-6 custom-pad-20">
                      <div className="tp-contact-form-field mb-20">
                        <input
                          type="text"
                          name="fullName"
                          placeholder="Full name *"
                          value={formData.fullName}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 custom-pad-20">
                      <div className="tp-contact-form-field mb-20">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email Address *"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 custom-pad-20">
                      <div className="tp-contact-form-field mb-20">
                        <input
                          type="text"
                          name="phone"
                          placeholder="Phone"
                          value={formData.phone}
                          onChange={handleChange}
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 custom-pad-20">
                      <div className="tp-contact-form-field select-field-arrow mb-20">
                        <select
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          disabled={isLoading}
                        >
                          <option value="">Choose Subject</option>
                          <option value="Nettoyage de la maison">
                            Nettoyage de la maison
                          </option>
                          <option value="Nettoyage de bureaux">
                            Nettoyage de bureaux
                          </option>
                          <option value="Nettoyage de Cuisine">
                            Nettoyage de Cuisine
                          </option>
                          <option value="Club Cleaning">Club Cleaning</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12 custom-pad-20">
                      <div className="tp-contact-form-field mb-20">
                        <textarea
                          name="message"
                          placeholder="Your Message *"
                          value={formData.message}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                          rows="5"
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-md-12 custom-pad-20">
                      <div className="tp-contact-form-field">
                        <button
                          type="submit"
                          className="theme-btn text-white"
                          disabled={isLoading}
                          style={{
                            opacity: isLoading ? 0.7 : 1,
                            cursor: isLoading ? "not-allowed" : "pointer",
                          }}
                        >
                          {isLoading ? (
                            <>
                              <i className="flaticon-enter"></i>
                              <span style={{ marginLeft: "10px" }}>
                                Envoi en cours...
                                <span
                                  className="loading-dots"
                                  style={{ marginLeft: "5px" }}
                                >
                                  ...
                                </span>
                              </span>
                            </>
                          ) : (
                            <>
                              <i className="flaticon-enter"></i> Send Message
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactForm;
